export class SideMenu {
    private lenght: number;
    menu: boolean[];

    constructor(lenght: number = 10) {
        this.lenght = lenght;
        //dashboard (0), contracts (1), sales (2), users (3), profile (4), carte (5), statistiche (6), comunicazioni (7), route-permissions (8), agenti e op. agenzia (9)
        this.menu = new Array(length).fill(false);
    }

    setMenu(index: number) {
        if (this.menu[index] === true) {
            this.menu = new Array(this.lenght).fill(false);
        } else {
            this.menu = new Array(this.lenght).fill(false);
            this.menu[index] = true;
        }
    }

    getMenu(index: number) {
        return this.menu[index];
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/common/menu.model.ts